import React, {FC, useEffect} from 'react';
import {
	AgentState,
	LiveKitRoom,
	RoomAudioRenderer,
} from '@livekit/components-react';
import {AudioPresets} from 'livekit-client';

import '@livekit/components-styles';

import {Controls} from './Controls';
import {KrispEnabler} from './KrispEnabler';
import {useConnection} from './useConnection';
import {VoiceBars} from './VoiceBars';

import * as styles from './styles.module.scss';

type AgentProps = {
	report: string
	onState: (state: AgentState) => void
}

export const Agent: FC<AgentProps> = ({report, onState}) => {
	const {connection, onConnect} = useConnection(report);
	useEffect(() => {
		onConnect();
	}, []);

	return (
		<div className={styles.wrapper}>
			<LiveKitRoom
				serverUrl={connection?.serverUrl}
				token={connection?.participantToken}
				audio={true}
        		video={false}
				options={{
					audioCaptureDefaults: {
						channelCount: 1,
						sampleRate: 24000,
						sampleSize: 16,
					},
					publishDefaults: {
						audioPreset: AudioPresets.speech,
					},
				}}
			>
				<RoomAudioRenderer />
				<VoiceBars onState={onState} />
				<Controls />
				<KrispEnabler />
			</LiveKitRoom>
		</div>
	);
};
